import { html  } from 'lit';
import IVPLitElementBase from './lit-element-base.js';
import Api from './api.js'
import Auth from '../auth.js';

export default class IVPForm extends IVPLitElementBase {

	static get tag() { return "ivp-form" }

    static get properties() {
        return {
            //fields: { type: Array },
        };
    }

    constructor(fields,buttons) {
        super();
        
        this.fields = fields
        this.buttons = buttons
        if (this.buttons == null)
            this.buttons = []
    }

    render() {
        return html`
        <form class="form-horizontal px-3" @submit="${this._OnEvtSubmit}">
            ${this.fields.map((field)=>{
                return this._RenderField(field)
            })}

            <div class="d-flex justify-content-center">
            ${this.buttons.map((field)=>{
                return this._RenderButton(field)
            })}  
            </div>          
        </form>
        `
    }
    
    firstUpdated(changedProps) {
        $('[data-toggle="input-mask"]').each(function(a,e){var t=$(e).data("maskFormat"),n=$(e).data("reverse");null!=n?$(e).mask(t,{reverse:n}):$(e).mask(t)})
    }

    _RenderField(field) {
        if (field.length == null)
            field.length = "8"

        switch(field.type) {
            case 'email':
            case 'text':
            case 'phone':
            case 'number':
                return html`
                    <div class="form-group row mb-3">
                        <label for="${field.name}" class="col-3 col-form-label">${field.label}</label>
                        <div class="col-${field.length}">
                            <input type="${field.type}" ?disabled=${field.disabled} data-mask-format="${field.data_mask}" 
                                class="field form-control" id="${field.name}" placeholder="${field.placeholder}" value="${field.value}">                                            
                        </div>
                    </div>
                `
            case 'money':
                return html`
                    <div class="form-group row mb-3">
                        <label for="${field.name}" class="col-3 col-form-label">${field.label}</label>
                        <div class="col-${field.length}">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" >€</span>
                                </div>
                                <input type="text" id="${field.name}" ?disabled=${field.disabled} class="field form-control" style="text-align:right" value="${this._FormatMoney(field.value)}" />                                                
                            </div>                                                
                        </div>
                    </div>       
                    
                `
    
            case 'hidden':
                return html`
                    <input type="hidden" class="field" id="${field.name}" value="${field.value}">                                            
                `
            case 'select':
                return html`
                <div class="form-group row mb-3">
                    <label for="${field.name}" class="col-3 col-form-label">${field.label}</label>
                    <div class="col-${field.length}">
                        <select class="form-control mb-3 field" id="${field.name}" ?disabled=${field.disabled} value="${field.value}">
                            ${field.options.map((el) =>
                                html` <option ?selected=${field.value==el.value} value="${el.value}">${el.label}</option>`
                            )}                           
                        </select>
                    </div>                            
                </div>                    
                `
        }    
    }

    _RenderButton(button) {
        let primary_class = ""
        if (button.primary == true)
            primary_class = "btn-primary"
        return html`
            <button type="submit" style="min-width:150px" class="btn btn-lg ${primary_class} waves-effect waves-light" ?disabled=${button.disabled} action="${button.action}">${button.label}</button>        
        `
    }

    async OnSubmit() {

    }

    async _OnEvtSubmit(evt) {
        evt.preventDefault()
        let fields = this.querySelectorAll("form .field")
        let submit = { 
            action: evt.submitter.getAttribute("action"),
            data: {},
        }
        for(let i=0;i<fields.length;i++) {
            submit.data[fields[i].id] = fields[i].value
        }

        await this.OnSubmit(submit)
    }

    _FormatMoney(amount) {
        let val = parseFloat(amount)
        const formatter = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
        
          });
        return formatter.format(val)
    }
}
IVPForm.RegisterElement()